// extracted by mini-css-extract-plugin
export default {"emptyState":"EmptyTableState_emptyState__CtMsu"};